const RecipientTypes = {
  CurrentOrg: 1,
  ChildOrgs: 2
};

Object.freeze(RecipientTypes);

export default RecipientTypes;